import { Box, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import React from "react";

export const HeroSection = () => {
  const xMovement = keyframes`
    0%,100% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(2.5px); 
    }
    50% {
      transform: translateX(5px); 
    }
    75% {
      transform: translateX(7.5px); 
    }
  `;
  return (
    <Box
      w="full"
      h="full"
      backgroundImage="/assets/home_banner.jpg"
      backgroundPosition="center"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDir="column"
    >
      <Box
        pos="absolute"
        left={{ base: "50%", sm: "56%" }}
        top="17%"
        boxSizing="content-box"
      >
        {/* for animation */}
        <Box
          willChange="transform"
          transform="translateY(5px)"
          animation={`${xMovement} 2s linear infinite`}
        >
          <Box
            w="50px"
            h="50px"
            borderRadius="50%"
            bg="#fff"
            boxSizing="border-box"
            boxShadow="inset 0 0 30px 0 #fff, inset 20px 0 30px #ffd400, inset -20px 0 30px red, inset 20px 0 300px #ff40d6, inset -20px 0 300px #e3ff4b, 0 0 50px #fff, -10px 0 100px #fbff00, 10px 0 80px #f55"
          ></Box>
        </Box>
      </Box>
      <Box pos="relative" paddingTop="10rem" textAlign="center">
        <Text
          as="h1"
          fontSize={{ base: "2.5rem", xsm: "10vw" }}
          letterSpacing="2.2px"
          textShadow="1px 3px 11px rgba(0,0,0.3)"
          fontWeight="600"
          color="#fff"
        >
          JAY MALLI
        </Text>
        <Text
          paddingTop={{ base: "2rem", smm: "3rem", lg: "5rem" }}
          as="h5"
          fontSize="1.5rem"
          letterSpacing="2.2px"
          fontWeight="500"
          color="#fff"
          mt="1.5rem"
        >
          SOFTWARE ENGINEER
        </Text>
      </Box>
    </Box>
  );
};
